import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ToastData, ToastState } from "./types";
import { TOAST_INITIAL_STATE } from "./config";

const initialState: ToastState = TOAST_INITIAL_STATE;

const options = {
  name: "toast",
  initialState,
  reducers: {
    openToast: (state: ToastState, action: PayloadAction<ToastData>) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    closeToast: (state: ToastState) => {
      state.isOpen = false;
      state.title = "";
      state.message = "";
      state.type = "success";
    },
  },
};

const toastSlice = createSlice(options);

export const { openToast, closeToast } = toastSlice.actions;

export const selectToastData = (state: { toast: ToastState }) => state.toast;

export default toastSlice.reducer;
